function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStripe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512.02 512.02",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M512.02 259.566c0-36.41-17.636-65.14-51.344-65.14-33.85 0-54.331 28.73-54.331 64.856 0 42.811 24.179 64.429 58.882 64.429 16.925 0 29.726-3.84 39.397-9.245V286.02c-9.672 4.836-20.765 7.823-34.846 7.823-13.796 0-26.028-4.836-27.592-21.619h69.549c.001-1.849.285-9.245.285-12.658zm-70.26-13.512c0-16.072 9.814-22.757 18.774-22.757 8.676 0 17.921 6.685 17.921 22.757H441.76zM351.445 194.426c-13.938 0-22.899 6.542-27.877 11.094l-1.849-8.818h-31.29V362.54l35.557-7.538.142-40.25c5.12 3.698 12.658 8.96 25.174 8.96 25.459 0 48.642-20.481 48.642-65.567-.141-41.247-23.609-63.719-48.499-63.719zm-8.534 97.995c-8.392 0-13.369-2.987-16.783-6.685l-.142-52.767c3.698-4.125 8.818-6.969 16.925-6.969 12.943 0 21.903 14.507 21.903 33.139.001 19.059-8.818 33.282-21.903 33.282zM241.503 186.034l35.699-7.68v-28.872l-35.699 7.538zM241.503 196.843h35.699v124.449h-35.699zM203.244 207.368l-2.276-10.525h-30.721v124.449h35.557v-84.341c8.391-10.952 22.614-8.96 27.023-7.396v-32.712c-4.551-1.706-21.192-4.835-29.583 10.525zM132.13 165.98l-34.704 7.396-.142 113.924c0 21.05 15.787 36.553 36.837 36.553 11.663 0 20.196-2.134 24.89-4.694v-28.872c-4.551 1.849-27.023 8.391-27.023-12.658v-50.491h27.023v-30.294h-27.023l.142-30.864zM35.984 232.969c0-5.547 4.551-7.68 12.089-7.68 10.809 0 24.463 3.271 35.273 9.103v-33.424c-11.805-4.693-23.468-6.542-35.273-6.542C19.201 194.426 0 209.502 0 234.676c0 39.255 54.047 32.997 54.047 49.922 0 6.543-5.689 8.676-13.654 8.676-11.805 0-26.881-4.836-38.828-11.378v33.85c13.227 5.689 26.597 8.107 38.828 8.107 29.583 0 49.922-14.65 49.922-40.108-.142-42.384-54.331-34.846-54.331-50.776z",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    fill: "#635bff",
    "data-original": "#635bff",
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStripe);
export default __webpack_public_path__ + "static/media/stripe.64c366262c19e9df4bc35a40126c1003.svg";
export { ForwardRef as ReactComponent };